const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  error: (...args: unknown[]): void => {
    if (isDev) {
      console.error(...args);
    }
  },
  warn: (...args: unknown[]): void => {
    if (isDev) {
      console.warn(...args);
    }
  },
  log: (...args: unknown[]): void => {
    if (isDev) {
      console.log(...args);
    }
  },
};
